/**
 * The Opus app is embedded with the user's Firebase token, which doesn't know which branch (office) the user is working in.
 * The office is passed in the URL, so that Opus can start its session in it - otherwise the user's default office is used.
 *
 * @param url the Opus url
 * @param companyID the branch (office) company the user is working in, for users that don't work in an office there's none to pass
 */
export const addOpusCompanyID = (
  url: string,
  companyID: string | undefined
): string => {
  if (!companyID) {
    return url
  }

  const separator = url.includes("?") ? "&" : "?"

  return `${url}${separator}companyID=${encodeURIComponent(companyID)}`
}
